module.exports = __webpack_public_path__ + "static/media/wave.ba2b8e10.png";